module.exports = __webpack_public_path__ + "static/img/FPX-1.62f7123.webp";


//////////////////
// WEBPACK FOOTER
// ./static/website/images/FPX-1.webp
// module id = YT8c
// module chunks = 22